import React from 'react';
import { Redirect } from 'react-router-dom';

import fetch from '../../utils/fetcher';
import { AuthUserContext } from '../common/Session';

class Logout extends React.Component {
  componentDidMount() {
    fetch(`${process.env.REACT_APP_API_URL}/user/logout`, {
      method: 'GET',
      credentials: 'include',
    });
  }

  render() {
    return (
      <AuthUserContext.Consumer>
        {({ logout }) => {
          logout()
          return <Redirect to="/login" />
        }}
      </AuthUserContext.Consumer>
    )
  }
}


export default Logout;
